import {
  take,
  call,
  put,
  cancelled,
  fork,
  cancel,
  select
} from 'redux-saga/effects'
import { getTokenUser } from '../apis/user'
import {
  loginError,
  loginSuccess,
  clearUserInfo,
  updateUserInfo,
  updateAccessPermission,
  LOGIN_REQUEST,
  LOGOUT,
  LOGIN_ERROR
} from '../actions/user'

function* authorize(user, password) {
  try {
    const res = yield call(getTokenUser, user, password)
    yield put(updateUserInfo(res))
    yield put(updateAccessPermission(res.roles))
    yield put(loginSuccess(res))
  } catch (error) {
    yield put(loginError(error.message))
  } finally {
    if (yield cancelled()) {
    }
  }
}

export function* loginFlow() {
  while (true) {
    const userInfo = yield select(state => state.user || {})
    let task
    if (!userInfo || !userInfo.accessToken) {
      const { user, password } = yield take(LOGIN_REQUEST)
      task = yield fork(authorize, user, password)
    }
    const action = yield take([LOGOUT, LOGIN_ERROR])
    if (action.type === LOGOUT && task) yield cancel(task)
    yield put(clearUserInfo())
  }
}
